"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stakeActivePercent = exports.isStakeLockUpInForce = exports.withdrawableFromStake = exports.stakeActions = exports.tokenIsListedOnLedger = exports.toSubAccMint = exports.toTokenMint = exports.toTokenId = exports.decodeAccountIdWithTokenAccountAddress = exports.encodeAccountIdWithTokenAccountAddress = exports.isEd25519Address = exports.isValidBase58Address = exports.MAX_MEMO_LENGTH = void 0;
const cryptoassets_1 = require("@ledgerhq/cryptoassets");
const web3_js_1 = require("@solana/web3.js");
const utils_1 = require("./utils");
exports.MAX_MEMO_LENGTH = 500;
const isValidBase58Address = (address) => {
    try {
        return Boolean(new web3_js_1.PublicKey(address));
    }
    catch (_) {
        return false;
    }
};
exports.isValidBase58Address = isValidBase58Address;
const isEd25519Address = (address) => {
    return web3_js_1.PublicKey.isOnCurve(new web3_js_1.PublicKey(address).toBytes());
};
exports.isEd25519Address = isEd25519Address;
function encodeAccountIdWithTokenAccountAddress(accountId, address) {
    return `${accountId}+${address}`;
}
exports.encodeAccountIdWithTokenAccountAddress = encodeAccountIdWithTokenAccountAddress;
function decodeAccountIdWithTokenAccountAddress(accountIdWithTokenAccountAddress) {
    const lastColonIndex = accountIdWithTokenAccountAddress.lastIndexOf("+");
    return {
        accountId: accountIdWithTokenAccountAddress.slice(0, lastColonIndex),
        address: accountIdWithTokenAccountAddress.slice(lastColonIndex + 1),
    };
}
exports.decodeAccountIdWithTokenAccountAddress = decodeAccountIdWithTokenAccountAddress;
function toTokenId(mint) {
    return `solana/spl/${mint}`;
}
exports.toTokenId = toTokenId;
function toTokenMint(tokenId) {
    return tokenId.split("/")[2];
}
exports.toTokenMint = toTokenMint;
function toSubAccMint(subAcc) {
    return toTokenMint(subAcc.token.id);
}
exports.toSubAccMint = toSubAccMint;
function tokenIsListedOnLedger(mint) {
    var _a;
    return ((_a = (0, cryptoassets_1.findTokenById)(toTokenId(mint))) === null || _a === void 0 ? void 0 : _a.type) === "TokenCurrency";
}
exports.tokenIsListedOnLedger = tokenIsListedOnLedger;
function stakeActions(stake) {
    const actions = [];
    if (stake.withdrawable > 0) {
        actions.push("withdraw");
    }
    switch (stake.activation.state) {
        case "active":
        case "activating":
            actions.push("deactivate");
            break;
        case "deactivating":
            actions.push("reactivate");
            break;
        case "inactive":
            actions.push("activate");
            break;
        default:
            return (0, utils_1.assertUnreachable)(stake.activation.state);
    }
    return actions;
}
exports.stakeActions = stakeActions;
function withdrawableFromStake({ stakeAccBalance, activation, rentExemptReserve, }) {
    switch (activation.state) {
        case "active":
        case "activating":
            return stakeAccBalance - rentExemptReserve - activation.active - activation.inactive;
        case "deactivating":
            return stakeAccBalance - rentExemptReserve - activation.active;
        case "inactive":
            return stakeAccBalance;
        default:
            return (0, utils_1.assertUnreachable)(activation.state);
    }
}
exports.withdrawableFromStake = withdrawableFromStake;
function isStakeLockUpInForce({ lockup, custodianAddress, epoch, }) {
    if (custodianAddress === lockup.custodian.toBase58()) {
        return false;
    }
    return lockup.unixTimestamp > Date.now() / 1000 || lockup.epoch > epoch;
}
exports.isStakeLockUpInForce = isStakeLockUpInForce;
function stakeActivePercent(stake) {
    var _a;
    const amount = (_a = stake.delegation) === null || _a === void 0 ? void 0 : _a.stake;
    if (amount === undefined || amount === 0) {
        return 0;
    }
    return (stake.activation.active / amount) * 100;
}
exports.stakeActivePercent = stakeActivePercent;
//# sourceMappingURL=logic.js.map